<div class="flxClmn">
    <div class="page-title-container flxRow">
        <div class="flxClmn-center f-1-0">
            <div class="page-title-inner-container flxRow">
                <span class="page-title">Quarantined Emails</span>
                <!--Information modal-->
                <more-info-c>
                    <div class="flxClmn vSpace05" style="flex: 1 0;">
                        <span style="font-weight: bold;">Actions</span>
                        <br/>
                        <span><b>View info</b> - display information about the email and the email content</span>
                        <span><b>Release</b> - allow the quarantined email to be sent out</span>
                        <span><b>Remove</b> - remove this email from the sender's sent items</span>
                        <span><b>Delete</b> - delete the record of this quarantined email</span>
                    </div>
                    <div class="flxClmn vSpace05" style="flex: 1 0;">
                        <span style="font-weight: bold;">Status</span>
                        <br/>
                        <span><b style="color: darkorange;">Quarantined</b> - the email has been quarantined due to an admin policy or restriction</span>
                        <span><b style="color: dimgray;">Pending release</b> - an admin has released this email from quarantined and allowed it to be sent out</span>
                        <span><b style="color: green;">Released</b> - the email has been sent out to the intended recipients</span>
                        <span><b style="color: red;">Removed</b> - the email has been removed from the sender's sent items</span>
                    </div>
                </more-info-c>
            </div>
            <div class="page-subtitle-container">
                <span class="page-subtitle">Emails quarantined by outbound rules and policies.</span>
				<span class="page-subtitle" style="margin-left: 5px;" *ngIf="userInfo?.user_role === dic.CONSTANTS.userRole.admin || userInfo?.user_role === dic.CONSTANTS.userRole.subAdmin">
					Add reviewers <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.policyManagement, dic.CONSTANTS.outboundRulesAndPoliciesPageTabs.reviewers]">here</a>.
				</span>
            </div>
        </div>
        <div class="control-and-info-icons flxRow"></div>
    </div>
    <div class="page-inner-content-holder no-scroll flxClmn">

        <!--emails table-->
        <trustifi-table-c
            class="trustifi-table" style="flex: 1 0; z-index: 5;"
            [list]="emails"
            [headers]="[
				{text:'Created', sortKey:'created', width: '100px'},
				{text:'Sender', sortKey:'user_email'},
				{text:'Recipients'},
				{text:'Subject', sortKey:'email_subject'},
				{text:'Status', sortKey:'status', width: '100px'},
				{text:'Category', sortKey:'type'},
				{text:'', width: '23px'},
			]"
            [cellsPrototype]="[
				{textKey: 'created', textType: 'dateAndTime'},
				{textKey: 'user_email', tooltip: true, style: {'display': 'block', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}},
				{html: 'recipientsCell'},
				{html: 'emailSubjectCell'},
				{html: 'statusCell'},
				{html: 'categoryCell'},
				{html: 'handledIndicatorCell'},
			]"
            [bulkActions] = "{
				enable: true,
				selectBulkActionCb:	selectMultipleEmailsAction,
				initBulkActionsFunction: showBulkQuarantinedActions
			}"
            [cellActions] = "{
				enable: true,
				selectItemActionCb:	selectEmailAction,
				initActionsFunction: showQuarantinedActions
			}"
            (searchFunction)="searchEmail($event.searchTerm, $event.activeFilters)"
            [filterData]="filterData"
            [options]="{
				exportToCsvFunction: exportToCsv,
				loadingTableFlag: loadingEmailsInProcess,
				refreshFunction: getQuarantinedEmails,
				isEllipsis: false,
				itemsNameSingular: 'email',
				defaultSortKey: '-created'
			}"
        >
			<ng-template #customCells let-item let-cellId="cellId">
				<!--category cells-->
				<div *ngIf="cellId === 'emailSubjectCell'" style="word-break: break-word;">
					<span tooltip="{{item.email_subject | sanitizeText}}">{{item.email_subject}}</span>
				</div>
				<!--status cells-->
				<div *ngIf="cellId === 'statusCell'">
					<span [ngStyle]="{'color': item.status === dic.CONSTANTS.quarantinedOutboundStatus.quarantined.value ? 'darkorange' : item.status === dic.CONSTANTS.quarantinedOutboundStatus.released.value ? 'darkgreen' : item.status === dic.CONSTANTS.quarantinedOutboundStatus.removed.value ? 'darkred' : 'dimgray', 'text-transform': item.status !== 'pending' ? 'capitalize': ''}">
                    	{{dic.CONSTANTS.quarantinedOutboundStatus[item.status] && dic.CONSTANTS.quarantinedOutboundStatus[item.status].display || item.status}}
                	</span>
					<span *ngIf="item.email_id?.source === 'journal'"> (Journal)</span>
				</div>
				<!--category cells-->
				<div *ngIf="cellId === 'categoryCell'" style="word-break: break-word;">
					<span>{{item.type}}</span>
					<span *ngIf="item.reason" tooltip="{{item.reason | sanitizeText}}"> ({{item.reason}})</span>
				</div>
				<!--handled indicator cells-->
				<div *ngIf="cellId === 'handledIndicatorCell'">
					<i [ngStyle]="!item.reviewed_completed && {'visibility': 'hidden'}"
					   class="far fa-check" style="color: green;"
					   tooltip="Email was handled by a reviewer"></i>
				</div>
				<div *ngIf="cellId === 'recipientsCell'" class="ellipsis" tooltip="{{item.recipients?.join(', ')}}">
					<span>{{item.recipients?.join(', ')}}</span>
				</div>
			</ng-template>
			<div tableButtons>
				<label style="display: block; flex: 0 1 auto; height: 32px;">Quarantined email data will be kept by {{corpname}} for <input style="text-align: center;" type="number" min="1" max="180" placeholder="Days" [(ngModel)]="retentionPeriod" (ngModelChange)="changeRetentionPeriod(retentionPeriod);"> days</label>
			</div>
        </trustifi-table-c>

    </div>

    <popup-c class="no-content-padding" *ngIf="showEmailInfoPopup" size="fullscreen">
        <div class="f-1-0 h100 w100 flxClmn" style="overflow: auto;" tabindex="0" [appAutoFocus]="true" focusDelay="20" (keydown.escape)="showEmailInfoPopup = null;">
            <!--Popup header-->
            <div class="flxClmn-around tp-popup-header" style="flex: 1 0; max-height: 155px; padding: 10px 20px; border-bottom: solid 1px lightgrey; z-index: 100; background: linear-gradient(90deg, white,white 58%, #e9e9e9ad), url('images/popup-header-bg.png'); background-size: auto; background-repeat: round;">
                <div class="flxRow-between" style="align-items: center;">
                    <div class="flxRow ellipsis hSpace2" style="align-items: center; padding-right: 5%;">
                        <img src="images/favicon/favicon-32x32.png" style="width: 20px; margin: 0; image-rendering: -webkit-optimize-contrast;">
                        <h3 class="ellipsis">{{showEmailInfoPopup.email.email_subject}}</h3>
                    </div>
                    <a (click)="showEmailInfoPopup = null">
                        <i class="far fa-times" style="font-size: 1.3rem; padding: 10px;"></i>
                    </a>
                </div>

                <div class="flxRow-between">
                    <div class="flxRow hSpace2" style="align-items: center;">
                        <div class="flxRow hSpace1" style="align-items: center;">
                                <span style="font-size: 1rem; color: dimgrey;">
                                    Category:
                                </span>
                            <span style="font-size: 1rem; font-weight: bold; color: darkorange;">
                                   {{showEmailInfoPopup.email.type}}
                                </span>
                        </div>
                        <div class="vertical-separator" style="border-width: 2px; margin: 0 1.5vw; border-color: darkgrey; border-left: none;"></div>
                        <div class="flxRow hSpace1" style="font-size: 1rem; align-items: center;">
                            <span style="color: dimgrey;">Sent from mailbox:</span>
                            <span style="color: dimgrey; font-weight: bold;">{{showEmailInfoPopup.email.user_email}}</span>
                        </div>
                    </div>
                </div>

                <div class="flxRow-between" style="align-items: center;">
                    <div class="flxRow hSpace1" style="align-items: center;">
						 <span style="font-size: 1rem; color: dimgrey;">
							Email Actions:
						</span>
                        <btn-c style="width: 140px;"
                             *ngIf="showEmailInfoPopup.email.status === dic.CONSTANTS.quarantinedOutboundStatus.quarantined.value || showEmailInfoPopup.email.status === dic.CONSTANTS.quarantinedActions.requestRelease.value"
                             btnTooltip="The email will be removed completely from the sender's sent items"
                             [isDisabled]="actionInProcess"
                             (action)="selectEmailAction(showEmailInfoPopup.email, dic.CONSTANTS.quarantinedOutboundActions.remove)">
                            Remove
                        </btn-c>
                        <btn-c style="width: 140px;"
                             *ngIf="allowReviewerReleaseEmail && showEmailInfoPopup.email.status === dic.CONSTANTS.quarantinedOutboundStatus.quarantined.value || showEmailInfoPopup.email.status === dic.CONSTANTS.quarantinedActions.requestRelease.value"
                             btnTooltip="Email will be released from quarantine"
                             [isDisabled]="actionInProcess"
                             (action)="selectEmailAction(showEmailInfoPopup.email, dic.CONSTANTS.quarantinedOutboundActions.release);">
                            Release
                        </btn-c>
                        <btn-c style="width: 140px;"
                             btnTooltip="This email will be marked as {{showEmailInfoPopup.email.reviewed_completed ?  'not ' : ''}}handled by a reviewer"
                             [isDisabled]="actionInProcess"
                             (action)="selectEmailAction(showEmailInfoPopup.email, dic.CONSTANTS.quarantinedOutboundActions.handled);">
                            {{showEmailInfoPopup.email.reviewed_completed ? 'Set not handled' : 'Set handled'}}
                        </btn-c>
						<div style="width: 20px;">
							<div class="loading-spinner" style="position: relative; left: unset; border-width: 3px; width: 20px; height: 20px;"
								 *ngIf="actionInProcess" ></div>
						</div>
						<div *ngIf="gs.reviewerInfo.is_security_reviewer" class="flxRow hSpace1" style="align-items: center; padding-left: 0.5rem; border-left: 1px solid;">
							 <span style="font-size: 1rem; color: dimgrey;">
								Security Reviewer Actions
							</span>
							<btn-c style="width: 140px;"
								   [isDisabled]="actionInProcess"
								   (action)="selectEmailAction(showEmailInfoPopup.email, dic.CONSTANTS.quarantinedActions.createIncident.display)">
								Create incident
							</btn-c>
						</div>
                    </div>
                    <span class="animated fadeIn" style="margin-left: 36px; align-self: flex-end; background: linear-gradient(-90deg, white, white 80%, rgba(255,255,255,0)); padding: 5px 20px; margin-right: -20px; width: fit-content; padding-left: 60px;"
                          *ngIf="messageInInfoPopup.message && !actionInProcess"
                          [ngStyle]="{'color' : messageInInfoPopup.type === 'success' ? 'darkgreen' : 'red'}">
                                {{messageInInfoPopup.message}}
					</span>
                </div>
            </div>

            <div class="flxClmn" style="flex: 1 0; overflow: auto;">
                <div class="threat-protection-grid h100" style="flex: 1 0; overflow: auto !important; padding: 0 0.75vw !important;">
                    <!--Message Analysis Data Card-->
                    <div class="threat-protection-card flxClmn ro10 co10" style="margin: 1.2vw !important;"
						 [ngClass]="{'co14' : !allowReviewerShowContent}"
                         [ngStyle]="{'height' : showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.malicious ? '390px' : '305px'}">
                        <div class="card-header flxRow-between" style="align-items: center;">
							<span class="card-title">
								Message Analysis
							</span>
                        </div>
                        <div class="flxClmn animated fadeIn" style="flex: 1 0; overflow: auto;">
                            <div class="flxClmn vSpace05" style="margin-bottom: 10px; font-size: 0.85rem; padding: max(15px,1vw); flex: 1 0;">
                                <div class="flxRow-between" style="align-items: center; margin: 0 0 15px;">
									<!--Warning label-->
									<span class="flxRow" style="align-items: center; font-size: 1.15rem; color: orangered;">
										<i class="far fa-exclamation-triangle" style="padding-right: 15px;"></i>
										{{showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.malicious ? 'A link in this email was found to be unsafe' : ''}}
										{{showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.maliciousFiles ? 'A file in this email was found to be unsafe' : ''}}
										{{showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.inappropriateContent ? 'Inappropriate content was detected in email' : ''}}
										{{showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.rules ? 'Email delivery was blocked by an outbound rule' : ''}}
										{{showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.blocklistRecipient ? 'Blocklisted Recipient' : ''}}
										{{showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.blocklistFilePolicy ? 'Blocklisted Attachments Policy' : ''}}
										{{showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.recipientFailure ? 'Email was not received due to a failure on recipient\'s side' : ''}}
										{{showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.accountCompromised ? '' : ''}}
									</span>

									<div *ngIf="showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.malicious">
										<btn-c style="font-size: 0.8rem; width: 110px;"
											   [isDisabled]="showEmailInfoPopup.email.info.rescanLinkInProcess"
											   [loading]="showEmailInfoPopup.email.info.rescanLinkInProcess"
											   endIcon="far fa-sync-alt"
											   (action)="openRescanLinkPopup()">
											Rescan Link
										</btn-c>
									</div>
								</div>
                                <!--Warning details-->
                                <div class="animated fadeIn flxClmn-center" style="padding: 15px; background: #f9f9f9; flex: 1 0;">
                                    <!--outbound rule-->
                                    <div class="flxRow hSpace1" style="font-size: 1rem;"
                                         *ngIf="showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.rules && showEmailInfoPopup.email.reason">
                                        <span>Rule name:</span>
                                        <a style="font-weight: bold; text-decoration: underline;"
                                           tooltip="click to go to outbound rules page"
										   [routerLink]="['/' + dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.policyManagement]">
                                            {{showEmailInfoPopup.email.reason}}
                                        </a>
                                    </div>
                                    <!--recipient failure-->
                                    <div class="flxClmn vSpace1" style="font-size: 1rem; flex: 1 0;"
                                         *ngIf="showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.recipientFailure && showEmailInfoPopup.email.reason">
                                        <span>Recipient's mailbox:</span>
                                        <span style="margin: auto; font-weight: 500; word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; padding: 0 15px;">
											{{showEmailInfoPopup.email.reason}}
										</span>
                                    </div>
									<!--blocklisted attachment type-->
									<table class="w100 simpleDataTable" *ngIf="showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.blocklistFilePolicy">

										<tr *ngIf="showEmailInfoPopup.email.info.blockType">
											<td><b>Policy block type: </b></td>
											<td>
												<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">
													{{showEmailInfoPopup.email.info.blockType}}
												</span>
											</td>
										</tr>

										<tr *ngIf="showEmailInfoPopup.email.info.fileName">
											<td><b>File name: </b></td>
											<td>
												<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">
													{{showEmailInfoPopup.email.info.fileName}}
												</span>
											</td>
										</tr>
										<tr *ngIf="showEmailInfoPopup.email.info.type">
											<td><b>File type: </b></td>
											<td>
												<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">
													{{showEmailInfoPopup.email.info.type}}
												</span>
											</td>
										</tr>
									</table>

									<!--blocklisted recipient-->
                                    <div class="flxClmn vSpace1" style="font-size: 1rem; flex: 1 0;"
                                         *ngIf="showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.blocklistRecipient && showEmailInfoPopup.email.reason">
										<span style="margin: auto; word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; padding: 0 15px;">
											Sending emails to <b>{{showEmailInfoPopup.email.reason}}</b> is blocked by an admin policy since this address or domain is blocklisted
										</span>
                                    </div>
                                    <!--inappropriate content-->
                                    <div class="flxClmn-evenly" style="flex: 1 0; align-items: center;"
                                         *ngIf="showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.inappropriateContent">
                                        <span style="text-align: center;">Plan is set to block outgoing emails which contain inappropriate content</span>
                                        <a style="font-size: 0.8rem; text-decoration: underline;"
										   [routerLink]="['/' + dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.policyManagement]">
                                            Go to outbound rules & policies page
                                        </a>
                                    </div>
                                    <!--malicious links-->
                                    <table class="w100 simpleDataTable" *ngIf="showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.malicious && showEmailInfoPopup.email.info">
                                        <tr *ngIf="showEmailInfoPopup.email.info.url">
                                            <th style="padding: 0; border: none; width: 150px;"></th>
                                            <th style="padding: 0; border: none;"></th>
                                        </tr>
                                        <tr *ngIf="showEmailInfoPopup.email.info.url">
                                            <td><b>URL address: </b></td>
                                            <td>
												<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">{{showEmailInfoPopup.email.info.url}}</span>
											</td>
                                        </tr>
                                        <tr *ngIf="showEmailInfoPopup.email.info.domain">
                                            <td><b>Domain: </b></td>
                                            <td>
                                                <span>{{showEmailInfoPopup.email.info.domain}}</span>
                                                <span *ngIf="showEmailInfoPopup.email.info.is_black_list"> (Blocklist)</span>
                                            </td>
                                        </tr>
                                        <tr *ngIf="showEmailInfoPopup.email.info.status">
                                            <td><b>Type: </b></td>
                                            <td>
                                                <span [ngStyle]="{'color': showEmailInfoPopup.email.info.status === 'Safe' ? 'green' : showEmailInfoPopup.email.info.status === 'Malicious' ? 'darkred' : 'inherit'}">
												  {{showEmailInfoPopup.email.info.status}}
												</span>
                                            </td>
                                        </tr>
                                        <tr *ngIf="showEmailInfoPopup.email.info.sub_status && showEmailInfoPopup.email.info.sub_status.length">
                                            <td><b>Detection{{showEmailInfoPopup.email.info.sub_status.length > 1 ? 's' : ''}}: </b></td>
                                            <td>
                                                <div class="flxClmn vSpace1">
                                                    <div *ngFor="let detection of showEmailInfoPopup.email.info.sub_status" class="flxRow hSpace1" style="color: darkred;">
                                                        <i class="far fa-exclamation-triangle"></i>
                                                        <span>{{detection.message}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><b>Current email status: </b></td>
                                            <td>
                                                <span style="text-transform: capitalize;">{{showEmailInfoPopup.email.status}}</span>
                                            </td>
                                        </tr>
                                    </table>

                                    <!--malicious file-->
                                    <table class="w100 simpleDataTable" *ngIf="showEmailInfoPopup.email.type === dic.CONSTANTS.quarantinedOutboundType.maliciousFiles && showEmailInfoPopup.email.info">
                                        <tr *ngIf="showEmailInfoPopup.email.info.file_name">
                                            <th style="padding: 0; border: none; width: 150px;"></th>
                                            <th style="padding: 0; border: none;"></th>
                                        </tr>
                                        <tr *ngIf="showEmailInfoPopup.email.info.file_name">
                                            <td><b>File name: </b></td>
                                            <td>
												<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">
													{{showEmailInfoPopup.email.info.file_name}}
												</span>
                                            </td>
                                        </tr>
										<tr *ngIf="showEmailInfoPopup.email.info.malware_type">
											<td><b>Malware Type: </b></td>
											<td>
												<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">
													{{showEmailInfoPopup.email.info.malware_type}}
												</span>
											</td>
										</tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="email-content-card is-showing-content outbound-quarantined ro13 co14" style="margin: 1.2vw !important; position: relative; height: 600px !important; max-height: 60vh !important; padding: 0 !important; order: unset;"
						 *ngIf="allowReviewerShowContent">
                        <div class="threat-protection-card flxClmn w100 h100" style="position: relative; z-index: 3; margin: 0;">
                            <div class="card-header flxRow-between" style="align-items: center;">
								<span class="card-title">
									Email Content
								</span>
                                <div class="flxRow hSpace1" [ngClass]="{'disabled' : !showEmailInfoPopup.email?.content}">
                                </div>
                            </div>

							<!--"show content" button for large size-->
							<div class="flxClmn-center" style="align-items: center; flex: 1 0; background: radial-gradient(transparent, #f5f8ff);"
								 [ngClass]="showEmailInfoPopup.loadingEmailContent && 'shinyFX'"
								 [ngStyle]="{'overflow' : showEmailInfoPopup.loadingEmailContent ? 'hidden' : 'auto'}"
								 *ngIf="!showEmailInfoPopup.email?.content">
								<btn-c class="show-email-large-btn" style="z-index: 5;"
									   [isDisabled]="showEmailInfoPopup.loadingEmailContent"
									   [loading]="showEmailInfoPopup.loadingEmailContent"
									   (action)="getQuarantinedEmailContent(showEmailInfoPopup.email);">
									Show Content
								</btn-c>
							</div>

                            <div *ngIf="showEmailInfoPopup.email?.content"
                                 class="input-wrap flxClmn vSpace05" style="flex: 1 0; overflow: auto; padding: 15px 20px 10px; background: #f9f9f9;">
                                <div style="background: white; padding: 15px;">
                                    <table class="w100 simpleDataTableShrink" style="table-layout: fixed;">
                                        <tr>
                                            <th style="padding: 0; max-height: 0; width: 55px;"></th>
                                            <th style="padding: 0; max-height: 0;"></th>
                                        </tr>
                                        <tr>
                                            <td><b>From: </b></td>
                                            <td>
                                                <span style="color: dimgrey;">{{showEmailInfoPopup.email.user_email}}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><b>To: </b></td>
                                            <td class="flxRow" [ngClass]="showEmailInfoPopup.email.contentObj.recipients.to.length>1 && 'hSpace05'" style="flex-wrap: wrap;">
												<span *ngFor="let recipient of showEmailInfoPopup.email.contentObj.recipients.to; let isLast = last;" style="color: dimgrey;">
													{{recipient.name && recipient.name !== recipient.address ? recipient.name + ' (' + recipient.address + ')' : recipient.address}}
													{{isLast ? '' : ','}}
												</span>
                                            </td>
                                        </tr>
                                        <tr *ngIf="showEmailInfoPopup.email.contentObj.recipients.cc.length">
                                            <td><b>Cc: </b></td>
                                            <td class="flxRow" [ngClass]="showEmailInfoPopup.email.contentObj.recipients.cc.length>1 && 'hSpace05'" style="flex-wrap: wrap;">
												<span *ngFor="let recipient of showEmailInfoPopup.email.contentObj.recipients.cc; let isLast = last;" style="color: dimgrey;">
													{{recipient.name && recipient.name !== recipient.address ? recipient.name + ' (' + recipient.address + ')' : recipient.address}}
													{{isLast ? '' : ','}}
												</span>
                                            </td>
                                        </tr>
                                        <tr *ngIf="showEmailInfoPopup.email.contentObj.recipients.bcc.length">
                                            <td><b>Bcc: </b></td>
                                            <td class="flxRow " [ngClass]="showEmailInfoPopup.email.contentObj.recipients.bcc.length>1 && 'hSpace05'" style="flex-wrap: wrap;">
												<span *ngFor="let recipient of showEmailInfoPopup.email.contentObj.recipients.bcc; let isLast = last;" style="color: dimgrey;">
													{{recipient.name && recipient.name !== recipient.address ? recipient.name + ' (' + recipient.address + ')' : recipient.address}}
													{{isLast ? '' : ','}}
												</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div id="quarantinedHtmlContainer" class="static-color" style="flex: 1 0; overflow: auto; background: white; padding: 25px;">
                                    <div id="quarantinedHtmlContainerData" style="display: inline; white-space: normal; margin: 0 0 0 1em;" [innerHTML]="showEmailInfoPopup.email.content || 'No data available.'"></div>
                                </div>
                                <div id="quarantinedAttachmentsContainer" *ngIf="showEmailInfoPopup.email.contentObj.sent.attachments.length">
                                    <hr style="width: 80%; margin: 10px auto;"/>
                                    <div class="flxRow hSpace1" style="margin: 0;">
                                        <div class="flxRow" style="flex:1 0; max-height: 66px; flex-wrap: wrap; overflow: auto;">
                                            <attachment-c
                                                    *ngFor="let file of showEmailInfoPopup.email.contentObj.sent.attachments"
                                                    [attName]="file.name"
                                                    [attSize]="file.size"
													[downloadProgress]="file.downloadProgressPrecentage"
													(preview)="previewAttachment = file;"
													(download)="downloadAttachment(file)">
                                            </attachment-c>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="threat-protection-card flxClmn ro14 co10" style="margin: 1.2vw !important;"
					[ngClass]="{'ro24' : !allowReviewerShowContent}">
                        <div class="card-header flxRow-between" style="align-items: center;">
							<span class="card-title">
								Tracking Details
							</span>
                        </div>
                        <div class="flxClmn" style="flex: 1 0; padding: max(15px,1vw); overflow: auto;">
                            <div class="flxClmn message-tab-content" style="width: 100%; max-width: 475px;" *ngIf="showEmailInfoPopup.email?.recipientTrack">
                                <div class="flxRow hSpace1" style="align-items: center;">
                                    <span style=" margin-top: -5px; font-weight: 500;">View tracking for: </span>
                                    <div style=" margin-left: 10px; height: 37px;">
                                        <app-dropdown-c style="width: 260px;"
                                                      [items]="showEmailInfoPopup.email.trackingData"
                                                      itemDisplayKey="email" enableSearch="true"
                                                      (onItemClicked)="changeTrackingRecipient($event.item)"
                                                      text="{{showEmailInfoPopup.email.recipientTrack.email}}"></app-dropdown-c>
                                    </div>
                                </div>

                                <div class="animated fadeIn" style="max-width: 585px; margin: 25px 0;" *ngIf="showEmailInfoPopup.email.recipientTrack">
                                    <ul class="icon-list" id="step19" style="white-space: nowrap;">
                                        <li [ngClass]="{'active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Sent') == 'success',
                                                          'current' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Sent') == 'failed',
                                                          'not-active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Sent') == 'none'}">
                                            <i class="far fa-envelope"><span class="icon-title">Sent</span></i>
                                        </li>
                                        <li *ngIf="archiveService?.currentMessage?.methods?.postmark"
                                            [ngClass]="{'active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Postmarked') == 'success',
                                                          'current' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Postmarked') == 'failed',
                                                          'not-active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Postmarked') == 'none'}">
                                            <i class="far fa-stamp"><span class="icon-title">Postmark</span></i>
                                        </li>
                                        <li [ngClass]="{'active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Delivery') == 'success',
                                                          'current' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Delivery') == 'failed',
                                                          'not-active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Delivery') == 'none'}">
                                            <i class="far fa-check-circle"><span class="icon-title">Delivered</span></i>
                                        </li>
                                        <li *ngIf="!showReadEvent(showEmailInfoPopup.email?.recipientTrack?.events_status)" [ngClass]="{'active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Opened') == 'success',
                                                          'current' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Opened') == 'failed',
                                                          'not-active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Opened') == 'none'}">
                                            <i class="far fa-envelope-open"><span class="icon-title">{{showEmailInfoPopup.email?.recipientTrack?.methods?.encrypt_content ? 'Opened' : 'Read'}}</span></i>
                                        </li>
                                        <li *ngIf="showReadEvent(showEmailInfoPopup.email?.recipientTrack?.events_status)" [ngClass]="{'active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Read') == 'success',
                                                          'current' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Read') == 'failed',
                                                          'not-active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Read') == 'none'}">
                                            <i class="far fa-envelope-open"><span class="icon-title">Read</span></i>
                                        </li>
                                        <li *ngIf="archiveService?.currentMessage?.methods?.secure_reply"
                                            [ngClass]="{'active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Reply Received') == 'success',
                                                           'current' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Reply Received') == 'failed',
                                                           'not-active' : (showEmailInfoPopup.email.recipientTrack.events_status | getTrackingEvent:'Reply Received') == 'none'}">
                                            <i class="far fa-reply"><span class="icon-title">Replied</span></i>
                                        </li>
                                        <li *ngIf="showEmailInfoPopup.email?.recipientTrack?.is_blocked">
                                            <i class="far fa-ban" style="font-size:50px; color:#c2272e; opacity:0.9;">
                                                <span class="icon-title">Blocked</span></i>
                                        </li>
                                    </ul>
                                </div>
                                <div id="step18 animated fadeIn" class="row alt" style="font-size: 14px; max-height: 32vh; overflow: auto;"
                                     *ngIf="showEmailInfoPopup.email.recipientTrack && showEmailInfoPopup.email.recipientTrack.track_events">
                                    <div class="several-cols">
                                        <div class="filter-box" *ngIf="trackEventShow != -1">
                                            <a (click)="expandAllTrackEvents()">Expand All</a>
                                        </div>
                                        <div class="filter-box" *ngIf="trackEventShow == -1">
                                            <a (click)="collapseAllTrackEvents()">Collapse All</a>
                                        </div>
                                    </div>
                                    <div class="several-cols"
                                         *ngFor="let track_event of showEmailInfoPopup.email.recipientTrack.track_events;">
                                        <a (click)="track_event.opened = !track_event.opened">
                                            <div class="several-cols__row">
                                                    <span class="name">
                                                        {{track_event.name}}
                                                        <img *ngIf="track_event.name == 'Read' && track_event.ll"
                                                             (click)="openLocation(track_event.ll)" tooltip="Open in Google Maps"
                                                             class="googleMaps"
                                                             src="data:image/png;base64,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"
                                                             alt=""/>
                                                    </span>
                                                <div class="date-box" style="width:50%;">
                                                    <time style="float: right; white-space: nowrap;">{{ track_event.created | date:'MM/dd/yyyy HH:mm'}}</time>
                                                </div>
                                            </div>
                                        </a>
                                        <ul class="content-info-list" *ngIf="track_event.opened">
                                            <li *ngFor="let event of track_event.info" [innerHTML]="event.msg"></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="flxClmn-center" style="align-items: center; flex: 1 0;"
                                 *ngIf="!showEmailInfoPopup.email?.recipientTrack">
                                        <span style="opacity: 0.7;" >
                                            No tracking data
                                        </span>
                            </div>
                        </div>
                    </div>
                    <div class="threat-protection-card flxClmn ro11 co14" style="min-height: 350px; margin: 1.2vw !important;">
                        <div class="card-header flxRow-between" style="align-items: center;">
                                    <span class="card-title">
                                        Reviewers Activity {{showEmailInfoPopup.email?.reviewer_actions?.length ? '(' + showEmailInfoPopup.email.reviewer_actions.length + ')' : ''}}
                                    </span>
                        </div>
                        <div class="flxClmn" style="flex: 1 0; align-items: center; padding: 15px; overflow: auto;"
                             [ngStyle]="{'justify-content' : !showEmailInfoPopup.email.reviewer_actions || !showEmailInfoPopup.email.reviewer_actions.length ? 'center' : ''}">
                            <table style="text-align: left; width:100%; table-layout: fixed;" class="simpleDataTable" *ngIf="showEmailInfoPopup.email.reviewer_actions && showEmailInfoPopup.email.reviewer_actions.length">
                                <tr>
                                    <th style="width: 20%;">Created</th>
                                    <th style="width: 25%;">Reviewer</th>
                                    <th style="width: 50%;">Action</th>
                                </tr>
                                <tr *ngFor="let actionObj of showEmailInfoPopup.email.reviewer_actions | orderBy: '-created'">
                                    <td >
                                        {{actionObj.created | date:'MM/dd/yyyy HH:mm'}}
                                    </td>
                                    <td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                                        {{actionObj.reviewer}}
                                    </td>
                                    <td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                                        <span style="display: block; width: fit-content; max-width: 100%;" tooltip="{{actionObj.action}}">{{actionObj.action}}</span>
                                    </td>
                                </tr>
                            </table>
                            <span style="opacity: 0.7;" *ngIf="!showEmailInfoPopup.email.reviewer_actions || !showEmailInfoPopup.email.reviewer_actions.length">
                                        No activity by reviewers
                                    </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </popup-c>

	<attachment-preview
		*ngIf="previewAttachment"
		[attachment]="previewAttachment"
		(onClose)="previewAttachment = null;"
		[url]="'/admin/outbound/quarantined/attachment/' + showEmailInfoPopup.email?._id + '/' + previewAttachment?._id">
	</attachment-preview>

	<!--Create Incident popup-->
	<popup-c class="bs-enabled" *ngIf="incidentPopup?.show"
			 head="Create Incident" size="dynamic"
			 (closeCb)="incidentPopup.show = false;"
			 (confirmCb)="incidentPopup?.doneCb()"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', disabled: incidentPopup.applyInProcess || !incidentPopup.securityTeamComments.length}}">
		<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
			<p style="font-size: 14px;">An email will be sent to all reviewers with details about this quarantined email. You can add your questions to the reviewers below.</p>

			<div class="d-flex flex-column gap-1">
				<div style="white-space: nowrap;">Security team comments</div>
				<textarea type="text" placeholder="Information needed from reviewers"
						  style="max-height: 100px;" rows="2" [required]="true" [(ngModel)]="incidentPopup.securityTeamComments">
			   </textarea>
				<div class="d-flex gap-2">
					<btn-c class="popup-action-btn bs-enabled"
						   startIcon="fa fa-magic"
						   [loading]="incidentPopup.generateInProcess"
						   [isDisabled]="incidentPopup.generateInProcess"
						   (action)="generateIncidentNote();">
						Improve Comment
					</btn-c>
				</div>
			</div>
		</div>

	</popup-c>
</div>
